import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { adminAPI } from '../../../utils/api';

const FeatureStatsTab = () => {
  const [features, setFeatures] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await adminAPI.getFeatureOverview();
        setFeatures(res.data.features || []);
      } catch (err) {
        console.error('Failed to fetch feature overview:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <Box sx={{ textAlign: 'center', padding: '48px', color: '#94A3B8' }}>Loading feature stats…</Box>;
  }
  if (!features) return null;

  return (
    <Box>
      <Box sx={{ fontSize: '14px', color: '#94A3B8', marginBottom: '20px' }}>
        Lighter stats for everything else — Trade Packages, Rate My Trade, marketplaces, and analyst reviews.
      </Box>
      <Grid container spacing={3}>
        {features.map((f) => (
          <Grid item xs={12} sm={6} md={3} key={f.key}>
            <Box
              sx={{
                background: '#1E293B',
                border: '1px solid #334155',
                borderRadius: '12px',
                padding: '20px',
                height: '100%',
                transition: 'all 0.2s',
                '&:hover': { borderColor: '#3B82F6', transform: 'translateY(-4px)' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <Box sx={{ fontSize: '22px' }}>{f.icon}</Box>
                <Box sx={{ fontSize: '13px', fontWeight: 600, color: '#94A3B8', textTransform: 'uppercase' }}>
                  {f.label}
                </Box>
              </Box>
              <Box sx={{ fontSize: '40px', fontWeight: 700, color: '#3B82F6', marginBottom: '12px' }}>
                {f.total}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#64748B' }}>
                <Box>Today<br /><Box component="span" sx={{ color: '#F1F5F9', fontWeight: 600, fontSize: '14px' }}>{f.today}</Box></Box>
                <Box>7d<br /><Box component="span" sx={{ color: '#F1F5F9', fontWeight: 600, fontSize: '14px' }}>{f.last7Days}</Box></Box>
                <Box>30d<br /><Box component="span" sx={{ color: '#F1F5F9', fontWeight: 600, fontSize: '14px' }}>{f.last30Days}</Box></Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeatureStatsTab;
